import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { User } from '../models';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

/** Mock client-side authentication/authorization service */
@Injectable({ providedIn: 'root' })
export class AuthService {

  public baseurl = environment.apiUrl;
  private accountApi = "api/Account/";
  private commonApi = "api/Common/";
  private planApi = "api/Plan/";

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(data) {
    const url = this.baseurl + this.accountApi + 'Login';
    return this.http.post<any>(url, data)
      .pipe(map(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if (user != null && user.isSuccess == true) {
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject.next(user);
        }
        return user;
      }));
  }

  IsUserAuthenticated() {
    const url = this.baseurl + this.accountApi + 'IsUserLoggedIn';
    return this.http.get(url);
  }

  registerUser(data){
    const url = this.baseurl + this.accountApi + 'Register'
    return this.http.post<any>(url, data)
    .pipe(map(user => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      if (user != null && user.isSuccess == true) {
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserSubject.next(user);
      }
      return user;
    }));
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('planText');
    this.currentUserSubject.next(null);
  }

  getAuthorizationToken() {
    return 'some-auth-token';
  }

  register(data) {
    const url = this.baseurl + this.accountApi + 'Register'
    return this.http.post(url, data).pipe()
  }

  getCountry() {
    const url = this.baseurl + this.commonApi + 'GetCountry';
    return this, this.http.get(url).pipe();
  }

  getAllCountries() {
    const url = this.baseurl + this.commonApi + 'GetAllCountries';
    return this, this.http.get(url).pipe();
  }

  checkEmailExist(model) {
    const url = this.baseurl + this.accountApi + 'checkEmailExist'
    return this.http.post(url, model).pipe()
  }
  forgotPassword(model) {
    const url = this.baseurl + this.accountApi + 'ForgotPassword'
    return this.http.post(url, model).pipe()
  }
  checkValidUserResetPassword(model) {
    const url = this.baseurl + this.accountApi + 'CheckValidUserResetPassword'
    return this.http.post(url, model).pipe()
  }

  resetPassword(model) {
    const url = this.baseurl + this.accountApi + 'ResetPassword'
    return this.http.post(url, model).pipe()
  }

  subcriptionPlan(planId, userId) {
    const url = this.baseurl + this.planApi + 'ActivateCanceSubcriptioByPlanId' + '?PlanId=' + planId + '&UserId='+userId;    
    return this, this.http.get(url).pipe();
  }

}
